import { ComponentConfig } from "@measured/puck";
import PdfExport, { PdfExportProps } from "./PdfExport";
import type { ColorPickerFieldProps } from "../../fields/ColorPickerField";
import ColorPickerField from "../../fields/ColorPickerField";

export type { PdfExportProps } from "./PdfExport";

const PdfExportConfig: ComponentConfig<PdfExportProps> = {
    label: "PDF Export",
    fields: {
        label: {
            type: "text",
            label: "Label",
        },
        url: {
            type: "text",
            label: "URL de la page à exporter",
        },
        width: {
            type: "select",
            label: "Width",
            options: [
                { label: "Default", value: "default" },
                { label: "Auto", value: "auto" },
                { label: "Full", value: "full" },
                { label: "Half", value: "half" },
            ],
        },
        position: {
            type: "radio",
            label: "Position",
            options: [
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
            ],
        },
        textColor: {
            type: "custom",
            render: (props: ColorPickerFieldProps) => <ColorPickerField {...props} />,
            label: "Text Color",
        },
        variant: {
            type: "select",
            label: "Variant",
            options: [
                { label: "body1 (Default)", value: "body1" },
                { label: "h1", value: "h1" },
                { label: "h2", value: "h2" },
                { label: "h3", value: "h3" },
                { label: "h4", value: "h4" },
                { label: "h5", value: "h5" },
                { label: "h6", value: "h6" },
                { label: "subtitle1", value: "subtitle1" },
                { label: "subtitle2", value: "subtitle2" },
                { label: "body2", value: "body2" },
                { label: "caption", value: "caption" },
                { label: "overline", value: "overline" },
            ],
        },
    },
    defaultProps: {
        label: "puck.blocks.pdf_export.label",
        url: "/",
        width: "default",
        position: "left",
        textColor: "#ffffff",
        variant: "body1",
    },
    render: (props: PdfExportProps) => {
        return <PdfExport {...props} />;
    },
};

export default PdfExportConfig;
